import React from 'react';
import { Tick02Icon, Remove01Icon } from 'hugeicons-react';
import { pricingTiers, PricingTier } from '../../Data/PricingData';
import '../../Styles/Pricing/PlanComparison.css';

type Cell = string | boolean;

const ROWS: { label: string; value: (t: PricingTier) => Cell }[] = [
    { label: 'Messages per Month', value: t => t.limits.messages.toLocaleString('en-US') },
    { label: 'Image Generations per Month', value: t => String(t.limits.images) },
    { label: 'File Uploads per Chat', value: t => String(t.limits.filesPerChat) },
    { label: 'Quiz Generation', value: () => true },
    { label: 'Spaces', value: t => t.limits.spaces },
    { label: 'Early Access to Beta Features', value: t => t.limits.betaFeatures },
    { label: 'Free Trial', value: t => (t.trialDays ? `${t.trialDays} Days` : false) },
];

const renderCell = (cell: Cell) => {
    if (cell === true) return <Tick02Icon size={18} className="plan-compare-yes" aria-label="Included" />;
    if (cell === false) return <Remove01Icon size={18} className="plan-compare-no" aria-label="Not included" />;
    return cell;
};

const PlanComparison: React.FC = () => (
    <section className="plan-compare" aria-labelledby="plan-compare-heading">
        <h2 id="plan-compare-heading">Compare Plans</h2>
        <div className="plan-compare-scroll">
            <table>
                <thead>
                    <tr>
                        <th scope="col"><span className="sr-only">Feature</span></th>
                        {pricingTiers.map(t => (
                            <th scope="col" key={t.idname} className={t.highlight ? 'is-highlighted' : ''}>{t.name}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {ROWS.map(row => (
                        <tr key={row.label}>
                            <th scope="row">{row.label}</th>
                            {pricingTiers.map(t => (
                                <td key={t.idname} className={t.highlight ? 'is-highlighted' : ''}>{renderCell(row.value(t))}</td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    </section>
);

export default PlanComparison;
